// src/sections/portfolio/data.js

import Image1 from '../../assets/project1.jpg';
import Image2 from '../../assets/project2.jpg';
import Image3 from '../../assets/project3.jpg';
import Image4 from '../../assets/project4.png';
import Image5 from '../../assets/project5.jpeg';
import Image6 from '../../assets/project6.png';
import Image8 from '../../assets/project8.png';

const data = [
  {
    id: 5,
    category: 'typescript',
    image: Image4,
    title: "KhoAI – Inventory & Transaction Management System",
    desc: "A multi-tenant inventory platform for managing stock, sales, and supplier orders — deployed to production on Railway and Cloudflare Pages. Features JWT authentication, session security, tiered access control, and Xendit payment integration. Built with TypeScript, Node.js, Hono, SolidJS, MongoDB, and Redis.",
    techStack: ['TypeScript', 'Node.js', 'SolidJS', 'MongoDB', 'Redis'],
    website: 'https://khoai.io',
  },
  {
    id: 7,
    category: 'ai',
    image: Image8,
    title: "Food Image Calorie Estimator",
    desc: "AI4All Technology and Machine Learning project using Python, PyTorch, pandas, and Kaggle. Collaborated on CNN-based Nutrition5k models to classify RGB food images into Low, Medium, and High calorie ranges, improving validation accuracy from 66% to 73%. Validated a 70/15/15 train-validation-test split across 3,244 RGB images and confirmed no dish-level leakage.",
    techStack: ['Python', 'PyTorch', 'pandas', 'CNN', 'Kaggle'],
    demo: 'https://calorieestimator.streamlit.app/',
  },
  {
    id: 2,
    category: 'ai',
    image: Image5,
    title: "GenFlash AI – AI-Powered Flashcard Generator",
    desc: "A web app that automatically generates flashcards from uploaded documents (PDF, DOCX, TXT) using AI. Reduced manual flashcard creation time by ~90% with AI-driven Q&A extraction. Features study mode, quiz mode, and progress tracking.",
    demo: 'https://genflash-ai.lovable.app/',
    github: 'https://github.com/kainguyen104/smart-flashcards',
  },
  {
    id: 6,
    category: 'ai',
    image: Image6,
    title: "HireReady AI – Cover Letter & Resume Assistant",
    desc: "An AI-powered web app that generates personalized cover letters and resume feedback from your resume and job description. Features tone selection, bilingual output (English/Vietnamese), skills match scoring, and one-click export. Built with React and TypeScript.",
    demo: 'https://readyforjob.lovable.app',
    github: 'https://github.com/kainguyen104/readyforjob',
  },
  {
    id: 1,
    category: 'python',
    image: Image1,
    title: "FinTrack – Budgeting & Analytics App",
    desc: "A personal finance tool built with Python and OOP principles. Features savings goals, spending analytics, and secure data storage with error handling and transaction management.",
    github: 'https://github.com/kainguyen104/fin-track',
  },
  {
    id: 3,
    category: 'ai',
    image: Image2,
    title: "Illness Insights – Symptom Analysis Platform",
    desc: "A responsive web app providing preventive health insights based on user input. Built with HTML, CSS, and JavaScript with accessibility and interactivity in mind.",
    github: 'https://github.com/kainguyen104/Illness_Insights',
  },
  {
    id: 4,
    category: 'typescript',
    image: Image3,
    title: "Gymaniac – Gym & Membership Management System",
    desc: "A gym management system using TypeScript, Node.js, and Vitest. Includes class scheduling, membership tracking, and session analytics with automated testing.",
    github: 'https://github.com/kainguyen104/gymaniac',
  },
];

export default data;
